import React from 'react';

export default class CheckboxInput extends React.Component {

    constructor(props) {
        super(props);
    }

    onChange(event) {
        const checked = event?.target?.checked==true;
        this.props.onChange && this.props.onChange(checked);
    }

    classNameGroup() {
        return `input-group ${this.props.className || ''} ${this.props.hidden ? "disappear" : "appear"}`;
    }

    classNameInput() {
        return 'form-control ui-number-input';
    }

    render() {
        const props = this.props;
        return (
            <div className={this.classNameGroup()}>
                <label htmlFor={props.name}>
                    <input ref={this.ref}
                           id={props.id}
                           name={props.name}
                           type="checkbox"
                           className={this.classNameInput()}
                           checked={this.props.value==true}
                           onChange={(event)=>this.onChange(event)}
                           disabled={this.props.disabled==true}
                    />
                    <span>{this.props.label}</span>
                </label>
            </div>
        );
    }

}